import { toast } from 'sonner';

// Opens an isolated new tab logged in as the impersonated user.
// Uses sessionStorage so the main tab's session is untouched.
export function openImpersonationWindow(data) {
  const { token, user: impersonatedUser, impersonated_by_name, impersonation_session_id, started_at } = data;
  const newWindow = window.open('', '_blank');
  if (!newWindow) {
    toast.error('Please allow popups to login as another user');
    return false;
  }
  newWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Logging in as ${impersonatedUser.full_name}...</title>
      <style>
        body { font-family: system-ui; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
        .loader { text-align: center; }
        .spinner { width: 40px; height: 40px; border: 3px solid #e5e5e5; border-top-color: #2563eb; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 16px; }
        @keyframes spin { to { transform: rotate(360deg); } }
      </style>
    </head>
    <body>
      <div class="loader">
        <div class="spinner"></div>
        <p>Logging in as <strong>${impersonatedUser.full_name}</strong>...</p>
      </div>
      <script>
        sessionStorage.setItem('impersonate_token', '${token}');
        sessionStorage.setItem('impersonate_user', '${JSON.stringify(impersonatedUser).replace(/'/g, "\\'")}');
        sessionStorage.setItem('impersonate_by_name', '${String(impersonated_by_name || '').replace(/'/g, "\\'")}');
        sessionStorage.setItem('impersonate_session_id', '${impersonation_session_id || ''}');
        sessionStorage.setItem('impersonate_started_at', '${started_at || ''}');
        setTimeout(() => { window.location.href = '/'; }, 500);
      </script>
    </body>
    </html>
  `);
  newWindow.document.close();
  toast.success(`Opened new window as ${impersonatedUser.full_name}`);
  return true;
}
